export default __webpack_public_path__ + "9207ee20dd951e769d060ceda4e31e21.svg";